import { render, staticRenderFns } from "./SpoiledResetButton.vue?vue&type=template&id=60fb0345&scoped=true&"
import script from "./SpoiledResetButton.vue?vue&type=script&lang=js&"
export * from "./SpoiledResetButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fb0345",
  null
  
)

export default component.exports